import dynamic from "next/dynamic";

export const NavbarLogo = dynamic(
  () => import("./navbar-logo-ui").then((mod) => mod.NavbarLogo),
  {
    ssr: false,
  }
);
